import { AxiosResponse } from "axios"
import axios from "../axios"
import {
    IAuditLogQueryParams,
    ILoginLogQueryParams,
    IOperlogDetailData,
    IOperlogFilterOptionsData,
    IOperlogListData,
    IOperlogListParams,
    IOperlogLoginDetailData,
    IOperlogLoginFilterOptionsData,
    IOperlogLoginListData,
    IOperlogLoginListParams,
    IOperlogLoginStatisticsData,
    IOperlogStatisticsData,
} from "./monitor.types"

/**
 * 操作日志列表 
 */
export function operlogList(params: IOperlogListParams) {
    return axios<IOperlogListData>({
        method: 'post',
        url: '/monitor/operlog/findPage',
        data: params,
    })
}

/**
 * 操作日志详情
 */
export function operlogDetail(id: number) {
    return axios<IOperlogDetailData>({
        method: 'get',
        url: `/monitor/operlog/detail/${id}`,
    })
}

/**
 * 操作日志筛选选项
 */
export function operlogFilterOptions() {
    return axios<IOperlogFilterOptionsData>({
        method: 'get',
        url: '/monitor/operlog/filterOptions',
    })
}

/**
 * 操作日志统计
 */
export function operlogStatistics(params: IAuditLogQueryParams) {
    return axios<IOperlogStatisticsData>({
        method: 'post',
        url: '/monitor/operlog/statistics',
        data: params,
    })
}

/**
 * 操作日志导出
 */
export function operlogExport(params: IAuditLogQueryParams) {
    return axios<Blob, AxiosResponse<Blob>, IAuditLogQueryParams>({
        responseType: 'blob',
        method: 'post',
        url: '/monitor/operlog/export',
        data: params,
        rawResponse: true,
    })
}

/**
 * 登录日志列表
 */
export function operlogLoginList(params: IOperlogLoginListParams) {
    return axios<IOperlogLoginListData>({
        method: 'post',
        url: '/monitor/logininfor/findPage',
        data: params,
    })
}

/**
 * 登录日志详情
 */
export function operlogLoginDetail(id: number) {
    return axios<IOperlogLoginDetailData>({
        method: 'get',
        url: `/monitor/logininfor/detail/${id}`,
    })
}

/**
 * 登录日志筛选选项
 */
export function operlogLoginFilterOptions() {
    return axios<IOperlogLoginFilterOptionsData>({
        method: 'get',
        url: '/monitor/logininfor/filterOptions',
    })
}

/**
 * 登录日志统计
 */
export function operlogLoginStatistics(params: ILoginLogQueryParams) {
    return axios<IOperlogLoginStatisticsData>({
        method: 'post',
        url: '/monitor/logininfor/statistics',
        data: params,
    })
}

/**
 * 登录日志导出
 */
export function operlogLoginExport(params: ILoginLogQueryParams) {
    return axios<Blob, AxiosResponse<Blob>, ILoginLogQueryParams>({
        responseType: 'blob',
        method: 'post',
        url: '/monitor/logininfor/export',
        data: params,
        rawResponse: true,
    })
}
